import stockpile from './stockpile.png';
import silo from './silo.png';
import stockpile1Output from './stockpile1Output.png';
import silo1Output from './silo1Output.png';
import surgeBin1Output from './surgeBin1Output.png';
import stockpile2Outputs from './stockpile2Outputs.png';
import surgeBin2Output from './surgeBin2Output.png';
import surgeBin1Output2 from './surgeBin1Output_2.png';
import surgeBin2Output2 from './surgeBin2Output_2.png';
import { UnitTypes } from 'unitData/types';
import type { UnitInfoStorageInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';

export const storageTypes = [
  {
    id: 1,
    displayName: 'Stockpile',
    image: stockpile,
  },
  {
    id: 2,
    displayName: 'Silo',
    image: silo,
  },
];

export const storageWith1OutPutTypes = [
  {
    id: 1,
    displayName: 'Surge pile, 1 output',
    image: stockpile1Output,
  },
  {
    id: 2,
    displayName: 'Silo, 1 output',
    image: silo1Output,
  },
  {
    id: 3,
    displayName: 'Surge bin, 1 output',
    image: surgeBin1Output,
  },
];

export const storageWith2OutPutTypes = [
  {
    id: 1,
    displayName: 'Surge pile, 2 outputs',
    image: stockpile2Outputs,
  },
  {
    id: 2,
    displayName: 'Surge bin, 2 outputs',
    image: surgeBin2Output,
  },
];

export const storageTypes2 = [
  {
    id: 1,
    displayName: 'Stockpile',
    image: stockpile,
  },
  {
    id: 2,
    displayName: 'Silo',
    image: silo,
  },
];

export const storageWith1OutPutTypes2 = [
  {
    id: 1,
    displayName: 'Surge pile, 1 output',
    image: stockpile1Output,
  },
  {
    id: 2,
    displayName: 'Silo, 1 output',
    image: silo1Output,
  },
  {
    id: 3,
    displayName: 'Surge bin, 1 output',
    image: surgeBin1Output2,
  },
];

export const storageWith2OutPutTypes2 = [
  {
    id: 1,
    displayName: 'Surge pile, 2 outputs',
    image: stockpile2Outputs,
  },
  {
    id: 2,
    displayName: 'Surge bin, 2 outputs',
    image: surgeBin2Output2,
  },
];

export const getImageStorage = (type: number) => {
  if (type === storageTypes[0].id) {
    return stockpile;
  } else {
    return silo;
  }
};

export const getImageStorageWith1Output = (type: number) => {
  if (type === storageWith1OutPutTypes[0].id) {
    return stockpile1Output;
  } else if (type === storageWith1OutPutTypes[1].id) {
    return silo1Output;
  } else {
    return surgeBin1Output;
  }
};

export const getImageStorageWith2Outputs = (type: number) => {
  if (type === storageWith2OutPutTypes[0].id) {
    return stockpile2Outputs;
  } else {
    return surgeBin2Output;
  }
};

export const FEEDER_OUTPUT_OPTIONS = [
  { displayName: 'in % of input', value: 'PERCENT' },
  { displayName: 'in tph', value: 'TON' },
];

export const getDefaultData = (type: UnitTypes, variantId?: number) => {
  const unitInfo: UnitInfoStorageInterface = {
    storageImg: variantId ?? storageTypes[0].id,
    parallelUnits: 1,
    useAsHighBin: false,
    feedInOut: true,
    showOversize: false,
    amountRight: 50,
    feederOutputOptions: FEEDER_OUTPUT_OPTIONS[0].value,
    rightPanFeederModelName: 'SP0715',
    leftPanFeederModelName: 'SP0715',
    otherRightPanFeederModelName: '',
    otherLeftPanFeederModelName: '',
    otherModelMaxCapacityRight: 0,
    otherModelMaxCapacityLeft: 0,
    moisture: 0,
    newMoisture: false,
    mining: false,
    ulip: false,
    amountLeft: 50,
    inclinationRight: 8,
    inclinationLeft: 8,
    autoSelect: true,
    byProduct: false,
    display: {
      displayUnitName: true,
      displayTotalStoredMass: false,
      displayProductSize: true,
      displayMoisture: false,
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
    },
    storageImageId: 0,
    otherModelRight: false,
    otherModelLeft: false,
    nominalCapacity: 0,
    modelName: '',
  };

  if (type === UnitTypes.STORAGE) {
    unitInfo.display['displayPredictedOversize'] = false;
  } else if (type === UnitTypes.STORAGE_FEEDER) {
    unitInfo.display['displayFeederModel'] = false;
    unitInfo.display['displayLoad'] = false;
    unitInfo.display['displayHighBin'] = true;
  } else if (type === UnitTypes.STORAGE_FEEDER_2_OUTPUTS) {
    unitInfo.display['displayFeederModel'] = false;
    unitInfo.display['displayLoad'] = false;
  }

  return unitInfo;
};

/**
 * Configuration for STORAGE, STORAGE_FEEDER, and STORAGE_FEEDER_2_OUTPUTS unit types.
 * Handles variant unit types via unitType parameter.
 */
export class StorageConfig extends BaseUnitConfig {
  getDefaultData(params?: UnitConfigParams): UnitInfoStorageInterface {
    const type = params?.unitType ?? UnitTypes.STORAGE;
    const variantId = params?.variantId;

    const unitInfo: UnitInfoStorageInterface = {
      storageImg: variantId ?? storageTypes[0].id,
      parallelUnits: 1,
      useAsHighBin: false,
      feedInOut: true,
      showOversize: false,
      amountRight: 50,
      feederOutputOptions: FEEDER_OUTPUT_OPTIONS[0].value,
      rightPanFeederModelName: 'SP0715',
      leftPanFeederModelName: 'SP0715',
      otherRightPanFeederModelName: '',
      otherLeftPanFeederModelName: '',
      otherModelMaxCapacityRight: 0,
      otherModelMaxCapacityLeft: 0,
      moisture: 0,
      newMoisture: false,
      mining: false,
      ulip: false,
      amountLeft: 50,
      inclinationRight: 8,
      inclinationLeft: 8,
      autoSelect: true,
      byProduct: false,
      display: {
        displayUnitName: true,
        displayTotalStoredMass: false,
        displayProductSize: true,
        displayMoisture: false,
        displayNotes: {
          noteOne: false,
          noteTwo: false,
          noteThree: false,
          noteFour: false,
          noteFive: false,
        },
      },
      storageImageId: 0,
      otherModelRight: false,
      otherModelLeft: false,
      nominalCapacity: 0,
      modelName: '',
    };

    if (type === UnitTypes.STORAGE) {
      unitInfo.display['displayPredictedOversize'] = false;
    } else if (type === UnitTypes.STORAGE_FEEDER) {
      unitInfo.display['displayFeederModel'] = false;
      unitInfo.display['displayLoad'] = false;
      unitInfo.display['displayHighBin'] = true;
    } else if (type === UnitTypes.STORAGE_FEEDER_2_OUTPUTS) {
      unitInfo.display['displayFeederModel'] = false;
      unitInfo.display['displayLoad'] = false;
    }

    return unitInfo;
  }

  getNumberOfPorts(_model?: string, _config?: number): number {
    // Storage variants have different port configurations
    // This is determined by the unit type, but we need to handle
    // them dynamically based on which instance is being used
    // For now, return default, but this is handled by registry variant types
    return 1; // STORAGE: 1 input, 0 outputs
  }
}

// Export singleton instance
export const storageConfig = new StorageConfig();
